import 'prismjs/plugins/line-numbers/prism-line-numbers';
export {
  default as plugin
} from 'prismjs/plugins/line-numbers/prism-line-numbers.css';
